import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const getConversationMessages = async (selectedDomain: string, conversationId: number): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `conversation-messages?domain=${selectedDomain}&cid=${conversationId}`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        isEncrypted: true,
    });
}